import React from 'react';
import '../../styles/Filters/Filters.scss';
import {useDispatch, useSelector} from 'react-redux';
import useMediaQuery from '../../hooks/useMediaQuery';
import {
  active,
  toggleCountryFilter,
  toggleMoreFilters,
  changeActiveFilters,
  clearAllFilterCounts,
  hasBeenLoaded,
  filterActive,
  compareActive,
} from '../../redux/Filters';
import {toggleDisplayResults} from '../../redux/mobileDisplays';
import TranslationLabel from '../TranslationLabel';
import FilterGroup from './FilterGroup';

import FilterGroupings from '../../utils/FilterGroupings';

import {Accordion} from 'react-bootstrap';

function Filters({onToggleFilter}) {
  const isMobile = useMediaQuery('(max-width: 768px)');
    
  const dispatch = useDispatch();
  const countryFilterOpened = useSelector(state => state.showFilters.countryFilterOpened);

  const closeSideNav = () => {
    dispatch(active());
    dispatch(filterActive(false));
    dispatch(compareActive(false));
    dispatch(toggleCountryFilter(false));
    dispatch(toggleMoreFilters(false));
    dispatch(hasBeenLoaded());
    if (isMobile) {
      dispatch(toggleDisplayResults(true));
    }
  };

  const clearAllFilters = () => {
    dispatch(changeActiveFilters([]));
    dispatch(clearAllFilterCounts());
  };

  return (
    <div className="filtersWrapper d-flex flex-column">
      <div className="filters position-relative">
        <div className=" p-2 d-flex justify-content-between filter-header diagonal-stripes align-items-center">
          <div className="bold px-2">
            <TranslationLabel id="label_30" defaultValue="All Filters" />
          </div>
          <div className="close-filter bold fs-5 p-1" onClick={closeSideNav}>
            X
          </div>
        </div>
        <div
          className="text-decoration-underline p-2 text-right clear-all light"
          onClick={clearAllFilters}
          style={{cursor: 'pointer'}}
        >
          <TranslationLabel id="label_07" />
              </div>


        <div className="px-2">
          <Accordion defaultActiveKey={countryFilterOpened ? "0" : null}>
            {FilterGroupings.map(ftlr => {
              return (
                <FilterGroup
                  eventKey={ftlr.eventKey}
                  label={ftlr.label}
                  field={ftlr.field}
                  program_num={ftlr.program_num}
                  icon={ftlr.icon}
                  onToggleFilter={onToggleFilter}
                />
              );
            })}
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default Filters;
